import { IconButton, SnackbarContent } from '@patrianna/core-components'
import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import { Close } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import snackbarClasses from 'containers/GlobalSnackbar/styles.module.scss'
import content from 'prismic-translates/favorites-page.json'
import RichText from 'src/components/RichText'
import { useAppDispatch } from 'src/store/hooks'
import { closeSnackbar } from 'src/store/modules/snackbar/actions'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  action: 'added' | 'removed'
}

export default function FavoriteSnackbarMessage({ action }: Props) {
  const dispatch = useAppDispatch()
  const onClose = () => {
    dispatch(closeSnackbar())
  }

  return (
    <SnackbarContent
      className={snackbarClasses.info}
      message={
        <div id='client-snackbar' className={snackbarClasses.message}>
          <div
            data-testid='snackbar-message'
            className={cx(snackbarClasses.messageTextWrapper, classes.snackbarMessage)}
          >
            <RichText
              field={
                action === 'added' ? t('add_to_favorites_snackbar_message') : t('remove_to_favorites_snackbar_message')
              }
            />
          </div>
          <IconButton className={snackbarClasses.closeButton} onClick={onClose} dataTestId='close-snackbar-button'>
            <Close />
          </IconButton>
        </div>
      }
    />
  )
}
